export default function checkIsFeatureEnabled(featureName, featureFlags) {
  // Add null checks for required parameters
  if (!featureName || !featureFlags || !featureFlags.system || !featureFlags.tenant) {
    return 0
  }

  const envFeatureFlags = process.env.REACT_APP_FEATURE_FLAGS || '';
  const envFeatureList = envFeatureFlags.split(',').map((f) => f.trim());
  const isEnabledInEnv = envFeatureList.includes(featureName);

    if (!isEnabledInEnv) {
      return 0;
    }

    const systemFeatureConfig = featureFlags.system.find((item) => item.featureName === featureName);
    const tenantSettingForFeature = featureFlags.tenant[featureName];

    if (systemFeatureConfig && systemFeatureConfig.isSystemOverride === 1) {
      return systemFeatureConfig.systemEnabled;
    } else if (typeof tenantSettingForFeature === 'number') {
      return tenantSettingForFeature;
    } else {
      return systemFeatureConfig ? systemFeatureConfig.systemEnabled : 0;
    }
  }